import { isPlatformBetaOperator } from './platformBetaAccess';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
export function PlatformBetaRouteGuard({ children }: { children: React.ReactNode }) {
  const allowed = useAuthStore((s) => s.isAuthenticated && isPlatformBetaOperator(s.user));
  return allowed ? <>{children}</> : <Navigate to="/unauthorized" replace />;
}
